const colors = [
  '#FFFFFF',
  '#FFFDF6',
  '#A9A698',
  '#636360',
  '#FFEB00',
  '#E7B100',
  '#F9D1CC',
  '#EB6113',
  '#BF001E',
  '#7BC6EB',
  '#003D8A',
  '#00256A',
  '#00031F',
  '#006528',
  '#003026',
  '#4E1E64',
  '#580C11',
  '#231916',
  '#00556F',
  '#00966C',
  '#7EAE26',
  '#CB0046',
  '#EEE92D',
  '#091028',
  '#5D200D',
  '#DC7E47',
  '#85721A',
  '#D2A03B',
  '#777568',
]
export default colors